
import { useState, useEffect, useRef } from 'react';

/**
 * Hook para persistir estados de formulário (rascunhos) no sessionStorage.
 * @param key Chave única para o rascunho
 * @param initialState Estado inicial do formulário
 */
// Fix: Updated return type signature to support functional updaters (prev => ...) like standard React useState
export function useDraftState<T>(key: string, initialState: T): [T, (value: T | ((prev: T) => T)) => void, () => void, boolean] {
  const [state, setState] = useState<T>(initialState);
  const [isRestored, setIsRestored] = useState(false);
  const isFirstMount = useRef(true);
  const storageKey = `gd_draft_${key}`;

  // Carregar rascunho inicial
  useEffect(() => {
    const saved = sessionStorage.getItem(storageKey);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed && typeof parsed === 'object') {
          setState(parsed);
          setIsRestored(true);
        }
      } catch (e) {
        console.error(`[DraftState] Erro ao restaurar ${key}:`, e);
      }
    }
    isFirstMount.current = false;
  }, [storageKey]);

  // Salvar rascunho com debounce
  useEffect(() => {
    if (isFirstMount.current) return;

    const timeout = setTimeout(() => {
      // Verifica se o estado é diferente do inicial para não salvar objetos vazios
      if (JSON.stringify(state) !== JSON.stringify(initialState)) {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [state, storageKey, initialState]);

  const clearDraft = () => {
    sessionStorage.removeItem(storageKey);
    setState(initialState);
    setIsRestored(false);
  };

  // Fix: Replaced manual updateState with setState to support functional updaters
  return [state, setState, clearDraft, isRestored];
}
